import axiosInstance from "./../helper/axiosIntanceApiZalo";
import axios from './../helper/axiosIntanceApiLiveChat';
import { normalizeStringInObject } from "../utils/normalize";

function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach(key => formData.append(key, object[key]));
    return formData;
}
const accessToken= (params)=>{
    return axios.post('/accessToken', getFormData(normalizeStringInObject(params)));
}
const getConversation = (params) => {
    return axios.post('/conversation', getFormData(normalizeStringInObject(params)));
};
const getListRecentChat = (params) => { 
    return axios.post(`/listRecentChat`, normalizeStringInObject(params));
};
const sendMessage = (params) => {
    return axios.post(`/sendMessage`, getFormData(normalizeStringInObject(params)));
};
const listContactChat = (params) => {
    return axios.post(`/listContactChat`, getFormData(normalizeStringInObject(params)));
};



export default {
    getConversation,
    getListRecentChat,
    sendMessage,
    accessToken,
    listContactChat
}
